import { atom } from 'jotai/vanilla';
import type { Viewer } from '@view-model/Viewer/Viewer';

// Viewerの配列を保持する
export const viewersAtom = atom<Viewer[]>([]);
